export function base64ToBytes(base64: string): Uint8Array {
	const binString = atob(base64)
	return Uint8Array.from(binString, (m) => m.codePointAt(0) as number)
}

export function bytesToBase64(bytes: Uint8Array): string {
	const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("")
	return btoa(binString)
}

export function base64ToString(input: string): string {
	return new TextDecoder().decode(base64ToBytes(input))
}

export function stringToBase64(input: string): string {
	return bytesToBase64(new TextEncoder().encode(input))
}
